function parseCodedHours(codedHours) {
    var weekdayHours = { 0: {}, 1: {}, 2: {}, 3: {}, 4: {}, 5: {}, 6: {} };
    if (codedHours && codedHours.length > 0) {
        var days = codedHours.split(';');
        for (var i = 0; i < days.length; i++) {
            if (days[i].length > 0) {
                var hourParts = days[i].split('-');
                if (hourParts[1] && hourParts[1].length > 0 && hourParts[2] && hourParts[2].length > 0) {
                    weekdayHours[(i + 1) % 7].isOpen = true;
                    weekdayHours[(i + 1) % 7].openHour = hourParts[1];
                    weekdayHours[(i + 1) % 7].closeHour = hourParts[2];
                } else {
                    // matching up 0 to Sunday (0) for jquery getDay function
                    weekdayHours[(i + 1) % 7].isOpen = false;
                }
            }
        }
    }
    return weekdayHours;
}

//      loadAppointment - keep in mind that a user can open the appointment popup calendar, enter data and exit without submitting, and then re-open the appointment calendar
//          (in this case, we need to not rebuild the calender objects and time options slider selectors, and we need to re-present all previously entered data.
//      Also, a user can enter data and submit the appointment request.  In this case, if they reopen the calendar, we want it to be a clean form with no previously entered data in it.
//          (in this second case, we also don't want to rebuild calendar and time options slider selectors, but all previously submitted data should have been cleared after successful submittal

function loadAppointment({
    floorplanId,
    communityName,
    floorplanName,
    hoursCoded,
    startTimeBufferInMinutes = null,
    openingBuffer,
    closingBuffer,
    commentPlaceholder,
}) {
    $('#appointment-popup').css('opacity', '0');
    $('#appointment-popup').addClass('loading');
    $('#appointmentMissingInput').hide();
    $('#appointmentError').hide();
    $('#appointmentCommunityNameBanner').html(unescape(communityName));
    $('#appointmentCommunityName').val(unescapeHtml(communityName));
    if (floorplanName != null) {
        $('#appointmentFloorplanName').val(unescapeHtml(floorplanName));
        $('#appointmentFloorplan').val(floorplanId);
        $('#appointmentSelectFloorplanWrapper').hide();
    } else {
        $('#appointmentCommunity').val(floorplanId);
        $('#appointmentSelectFloorplanWrapper').show();
    }
    $('#appointmentLoader').hide();
    if ($('#appointmentComments').val() == '') {
        $('#appointmentComments').val(commentPlaceholder);
    }

    // if the form is using reCAPTCHA we want to make sure we reset this when the popup loads
    if (typeof reCaptchaWidgets !== 'undefined' && reCaptchaWidgets['appointment-popup-recaptcha'] != null) {
        grecaptcha.enterprise.reset(reCaptchaWidgets['appointment-popup-recaptcha']);
    }

    var weekdayHours = null;
    var defaultDate = new Date();
    var defaultDateTimePlusBuffer = defaultDate.getTime() + startTimeBufferInMinutes * 60 * 1000; // Adds buffer to current day (default 12 hours).
    var defaultMinDate = new Date(defaultDateTimePlusBuffer);
    defaultMinDate.setMinutes(15 * Math.ceil(defaultMinDate.getMinutes() / 15)); // Round up to next quarter minute.
    var defaultMinTime = '08:00';
    var defaultMaxTime = '18:00';
    var closedDays = [];
    var disabledWeekDays = [];
    if (hoursCoded && hoursCoded !== '') {
        // if hours specified in table
        weekdayHours = parseCodedHours(hoursCoded);
        var adjustedCloseTime = weekdayHours[defaultMinDate.getDay()].isOpen
            ? calculateCloseTimeWithBuffer(
                  parseInt(weekdayHours[defaultMinDate.getDay()].closeHour.split(':')[0]),
                  parseInt(weekdayHours[defaultMinDate.getDay()].closeHour.split(':')[1]),
                  closingBuffer,
              )
            : '0:00';
        if (
            weekdayHours[defaultMinDate.getDay()].isOpen &&
            (adjustedCloseTime.split(':')[0] < defaultMinDate.getHours() ||
                (adjustedCloseTime.split(':')[0] == defaultMinDate.getHours() &&
                    adjustedCloseTime.split(':')[1] <= defaultMinDate.getMinutes()))
        ) {
            defaultMinDate.setDate(defaultMinDate.getDate() + 1); //if the min date is after the closing time, move min date to the next day.
            defaultMinDate.setHours(0);
            defaultMinDate.setMinutes(0);
        }
        if (weekdayHours[defaultMinDate.getDay()].isOpen) {
            // if today is open, set minTime and maxTime to specified hours for today.
            defaultMinTime = weekdayHours[defaultMinDate.getDay()].openHour;
            defaultMaxTime = weekdayHours[defaultMinDate.getDay()].closeHour;
        } else {
            // if today is closed . . . set minTime and maxTime to next open day found.
            var dayToCheck = (defaultMinDate.getDay() + 1) % 7;
            var dayOffset = 1;
            var openDayFound = false;
            while (!openDayFound && dayOffset < 7) {
                if (weekdayHours[dayToCheck].isOpen) {
                    defaultMinDate.setDate(defaultMinDate.getDate() + dayOffset);
                    defaultMinDate.setHours(0);
                    defaultMinDate.setMinutes(0);
                    defaultMinTime = weekdayHours[defaultMinDate.getDay()].openHour;
                    defaultMaxTime = weekdayHours[defaultMinDate.getDay()].closeHour;
                    openDayFound = true;
                } else {
                    dayToCheck = (dayToCheck + 1) % 7;
                    dayOffset++;
                }
            }
        } // defaultMinTime and defaultMaxTime now set 08:00-18:00 for non-table specified hours, or to next open day's opening/closing hours (does not take into account +12hr window closed, yet)
        for (var i = 0; i < 7; i++) {
            // initialize closedDays and disabledWeekDays arrays
            if (!weekdayHours[i].isOpen) {
                closedDays.push(i);
                disabledWeekDays[(i + 6) % 7] = 1;
            } else {
                disabledWeekDays[(i + 6) % 7] = 0;
            }
        }
    }
    var skippedDay = false;
    while (closedDays.indexOf(defaultMinDate.getDay() % 7) > -1) {
        // getDay gets day of week  - check to see if the (now+12hr) date is closed.
        defaultMinDate.setDate(defaultMinDate.getDate() + 1); // Add one or more days to the date if the community is closed the next day.
        skippedDay = true;
    }
    if (!skippedDay) {
        if (
            defaultMaxTime.split(':')[0] < defaultMinDate.getHours() ||
            (defaultMaxTime.split(':')[0] === defaultMinDate.getHours() &&
                defaultMaxTime.split(':')[1] <= defaultMinDate.getMinutes())
        ) {
            // if maxTime is less or equal to (now+12 hours) time
            var daysToAdd = 1;
            while (closedDays.indexOf((defaultMinDate.getDay() + daysToAdd) % 7) > -1) {
                // getDay gets day of week
                daysToAdd += 1;
            }
            defaultMinDate.setDate(defaultMinDate.getDate() + daysToAdd); // Add one or more days to the date if it's past community close time.        set date to next open day., set time to that
            if (weekdayHours) {
                // make sure we have the right open and close for the new day.
                defaultMinTime = weekdayHours[defaultMinDate.getDay()].openHour;
                defaultMaxTime = weekdayHours[defaultMinDate.getDay()].closeHour;
            }
        } else if (
            defaultMinTime.split(':')[0] < defaultMinDate.getHours() ||
            (defaultMinTime.split(':')[0] === defaultMinDate.getHours() &&
                defaultMinTime.split(':')[1] <= defaultMinDate.getMinutes())
        ) {
            defaultMinTime = make2Digits(defaultMinDate.getHours()) + ':' + make2Digits(defaultMinDate.getMinutes());
        }
    }
    if (defaultMinTime.length < 5) {
        defaultMinTime = '0' + defaultMinTime;
    }
    if (defaultMaxTime.length < 5) {
        defaultMaxTime = '0' + defaultMaxTime;
    }
    var defaultMinDateTime = defaultMinDate;
    defaultMinDateTime.setHours(parseInt(defaultMinTime.slice(0, 2)), parseInt(defaultMinTime.slice(3, 5)), 0, 0);

    var commonDatePickerOptions = {
        staticPos: true,
        noFadeEffect: false,
        rangeLow: defaultMinDateTime,
        disabledDays: disabledWeekDays,
        fillGrid: false,
        noTodayButton: true,
        hideInput: true,
        highlightDays: [0, 0, 0, 0, 0, 0, 0],
        noDrag: true,
        callbackFunctions: {
            dateset: [resetTimeSliderSelections, updateSelectedDateTimes],
            redraw: [touchUpCalendarAfterRedraw],
        },
    };

    var datePickerBuilt = $('#fd-appointmentFirstChoice-date').length > 0; // is the datepicker object / dom element already created?

    if (!datePickerBuilt) {
        datePickerController.createDatePicker(
            $.extend(
                // load the calendar for the 1st choice appt date selector
                {
                    // properties both 1) not in common or 2) with object values must be in the object.assign target here
                    formElements: {
                        'appointmentFirstChoice-date': '%d %F %Y',
                    },
                    positioned: 'first-choice-calendar-position',
                },
                commonDatePickerOptions,
            ),
        );
        datePickerController.setCursorDate(
            'appointmentFirstChoice-date',
            datePickerController.printFormattedDate(defaultMinDateTime, '%Y%m%d', true),
        ); // required for popup exit and reentry into calendar
    } else {
        var previouslySelectedFirstChoiceDateTime = $('#appointmentFirstChoice').val().trim(); // if previous selection has been made, no need to rebuild the date picker again
        var previouslySelectedFirstChoiceDateYYYYMMDD = previouslySelectedFirstChoiceDateTime
            .slice(6, 10)
            .concat(
                previouslySelectedFirstChoiceDateTime.slice(0, 2),
                previouslySelectedFirstChoiceDateTime.slice(3, 5),
            ); // yyyymmdd
    }

    if (!datePickerBuilt) {
        datePickerController.createDatePicker(
            $.extend(
                // load the calendar for the 2nd choice appt date selector
                {
                    formElements: {
                        'appointmentSecondChoice-date': '%d %F %Y',
                    },
                    positioned: 'second-choice-calendar-position',
                },
                commonDatePickerOptions,
            ),
        );
        datePickerController.setCursorDate(
            'appointmentSecondChoice-date',
            datePickerController.printFormattedDate(defaultMinDateTime, '%Y%m%d', true),
        ); // required for popup exit and reentry into calendar
    } else {
        var previouslySelectedSecondChoiceDateTime = $('#appointmentSecondChoice').val().trim();
        var previouslySelectedSecondChoiceDateYYYYMMDD = previouslySelectedSecondChoiceDateTime
            .slice(6, 10)
            .concat(
                previouslySelectedSecondChoiceDateTime.slice(0, 2),
                previouslySelectedSecondChoiceDateTime.slice(3, 5),
            ); // yyyymmdd
    }

    setTimeout(function () {
        // allows calendar to fully renders, or bad things happen like time sliders won't initialize correctly and width measurements are inaccurate for setting other element positions
        if ($('#appointmentFirstChoice-time-scroller .slick-track').length == 0) {
            // Only create the time sliders the first time into this popup
            initTimeSliders();
        }
        datePickerController.setSelectedDate(
            'appointmentFirstChoice-date',
            !!previouslySelectedFirstChoiceDateYYYYMMDD
                ? previouslySelectedFirstChoiceDateYYYYMMDD
                : defaultMinDateTime,
        ); // can't reset dates until time sliders are initialized since setting dates will trigger time slider rebuild
        datePickerController.setSelectedDate(
            'appointmentSecondChoice-date',
            !!previouslySelectedSecondChoiceDateYYYYMMDD
                ? previouslySelectedSecondChoiceDateYYYYMMDD
                : defaultMinDateTime,
        );
    }, 0);

    function initTimeSliders() {
        var isMobile = isMobilePage();
        if (isMobile) {
            var datePickerWidth = $('.appointment-date-container .date-picker').outerWidth();
            $('.time-scroller').outerWidth(datePickerWidth.toString() + 'px');
            $('.time-fade').outerWidth((datePickerWidth + 2).toString() + 'px');
        }

        var commonSliderOptions = {
            // slider options/config common to both mobile and desktop
            infinite: false,
            lazyLoad: 'progressive',
            circularSlider: false,
        };

        var desktopOptions = {
            // desktop options
            slidesToShow: 5,
            slidesToScroll: 4,
            vertical: true,
            mouseWheelScrolling: true,
        };

        var mobileOptions = {
            // mobile options
            slidesToShow: 1,
            slidesToScroll: 1,
            vertical: false,
            centerMode: true,
            variableWidth: true,
            swipe: true,
            swipeToSlide: false,
            initialSlide: 3,
            speed: 10,
            touchThreshold: 100,
            verticalSwiping: false,
            edgeFriction: 0,
        };

        loadSlickSlider(
            $.extend(
                {
                    // load the slider, adding options specific to the 1st choice appt time selector
                    sliderIdClass: 'appointmentFirstChoice-time-scroller',
                    prevArrowSelector: '#first-appointment-container ' + (isMobile ? '.leftArrow' : '.upArrow'),
                    nextArrowSelector: '#first-appointment-container ' + (isMobile ? '.rightArrow' : '.downArrow'),
                    beforeChangeCallback: function () {
                        saveSwipedPositionOffset('appointmentFirstChoice');
                    },
                    swipeCallback: function () {
                        snapScrollToSwipedPosition('appointmentFirstChoice');
                    },
                },
                commonSliderOptions,
                isMobile ? mobileOptions : desktopOptions,
            ),
        );

        loadSlickSlider(
            $.extend(
                {
                    // load the slider, adding options specific to the 2nd choice appt time selector
                    sliderIdClass: 'appointmentSecondChoice-time-scroller',
                    prevArrowSelector: '#second-appointment-container ' + (isMobile ? '.leftArrow' : '.upArrow'),
                    nextArrowSelector: '#second-appointment-container ' + (isMobile ? '.rightArrow' : '.downArrow'),
                    beforeChangeCallback: function () {
                        saveSwipedPositionOffset('appointmentSecondChoice');
                    },
                    swipeCallback: function () {
                        snapScrollToSwipedPosition('appointmentSecondChoice');
                    },
                },
                commonSliderOptions,
                isMobile ? mobileOptions : desktopOptions,
            ),
        );
    }

    function resetTimeSliderSelections(objFromDatePicker) {
        function convertToTime24(timeStringWithAmPm) {
            // examples of timeStringWithAmPM formatted 09:00AM or 09:00PM
            var hours = Number(timeStringWithAmPm.split(':')[0]);
            if (/pm/i.test(timeStringWithAmPm) && hours < 12) {
                // if pm or PM is in the string and hours < 12, then add 12 and return the 24 hour clock time
                return (hours + 12).toString() + timeStringWithAmPm.slice(2, 5);
            } else {
                return timeStringWithAmPm.slice(0, 5);
            }
        }

        var appointmentChoice =
            objFromDatePicker.id === 'appointmentFirstChoice-date'
                ? 'appointmentFirstChoice'
                : 'appointmentSecondChoice'; // identify the time scroller to update based on the calender that was just updated
        var currentDate = new Date();
        var minDate = new Date(currentDate.getTime() + startTimeBufferInMinutes * 60 * 1000); // Adds buffer to current day (default 12 hours).
        minDate.setMinutes(15 * Math.ceil(minDate.getMinutes() / 15)); // Round up to next quarter minute.
        var selectedDate = new Date(objFromDatePicker.date);
        var selectedDay = selectedDate.getDay();
        var newOpenTime = weekdayHours ? weekdayHours[selectedDay].openHour : '08:00';
        var newCloseTime = weekdayHours ? weekdayHours[selectedDay].closeHour : '18:00';
        if (
            newOpenTime.split(':')[0] < minDate.getHours() &&
            selectedDate.getFullYear() === currentDate.getFullYear() &&
            selectedDate.getMonth() === currentDate.getMonth() &&
            selectedDate.getDate() === currentDate.getDate()
        ) {
            newOpenTime = make2Digits(minDate.getHours()) + ':' + make2Digits(minDate.getMinutes());
        }
        if (newOpenTime.length < 5) {
            newOpenTime = '0' + newOpenTime;
        }
        if (newCloseTime.length < 5) {
            newCloseTime = '0' + newCloseTime;
        }
        $('.' + appointmentChoice + '-time-scroller').slick('slickUnfilter');

        // Separate hour/minute
        const openHour = parseInt(newOpenTime.split(':')[0]);
        const openMinute = parseInt(newOpenTime.split(':')[1]);

        // Calculate new "closing time" using the buffer
        const newOpenTimeWithBuffer = calculateOpenTimeWithBuffer(openHour, openMinute, openingBuffer);

        // Separate hour/minute
        var closeHour = parseInt(newCloseTime.split(':')[0]);
        var closeMinute = parseInt(newCloseTime.split(':')[1]);

        // Calculate new "closing time" using the buffer
        var newCloseTimeWithBuffer = calculateCloseTimeWithBuffer(closeHour, closeMinute, closingBuffer);

        var selectedTime = document.getElementById(appointmentChoice + '-time').value; // if a time slot had already been selected
        if (selectedTime) {
            //. . . check to see if it fits in the current window of the newly selected day. if so, we can keep it, and have slider slide to show the selection. If not, inform user and ensure slider is initialized
            var selectedTime24 = convertToTime24(document.getElementById(appointmentChoice + '-time').value); // if a time slot had already been selected
            if (selectedTime24 < newOpenTimeWithBuffer || selectedTime24 >= newCloseTimeWithBuffer) {
                $('#appointmentError')
                    .html(
                        'Your selected time slot, ' +
                            selectedTime +
                            ', is not available on this day. Please select an available time slot from the updated list.',
                    )
                    .show();
                document.getElementById(appointmentChoice + '-time').value = ''; // remove value from time input field
                if (isMobilePage()) {
                    $('.' + appointmentChoice + ' .selected-time-box').removeClass('time-has-been-selected');
                }
                $('.' + appointmentChoice + ' .appt-time-option')
                    .removeClass('time-picker-selected-time')
                    .attr('aria-selected', false); // remove the flags indicating this is the selected option from all other elements
                filterAndMapTimeOptionsList(
                    appointmentChoice,
                    newOpenTimeWithBuffer,
                    newCloseTimeWithBuffer,
                    selectedDate,
                    defaultMinDateTime,
                    true,
                );
                scrollToTimeOption(
                    appointmentChoice,
                    $('.' + appointmentChoice + ' .appt-time-option:nth-child(3)'),
                    true,
                ); // find and scroll to the third time option scroller to this so it is centered in the list of first 5 visible options
            } else {
                filterAndMapTimeOptionsList(
                    appointmentChoice,
                    newOpenTimeWithBuffer,
                    newCloseTimeWithBuffer,
                    selectedDate,
                    defaultMinDateTime,
                    false,
                );
                scrollToTimeOption(
                    appointmentChoice,
                    $('.' + appointmentChoice + ' .appt-time-option.time-picker-selected-time'),
                    true,
                ); // find selected item, and scroll the time option scroller to this so it is visible to user
            }
        } else {
            if (isMobilePage()) {
                $('.' + appointmentChoice + ' .selected-time-box').removeClass('time-has-been-selected');
            }
            $('.' + appointmentChoice + ' .appt-time-option')
                .removeClass('time-picker-selected-time')
                .attr('aria-selected', false);
            filterAndMapTimeOptionsList(
                appointmentChoice,
                newOpenTimeWithBuffer,
                newCloseTimeWithBuffer,
                selectedDate,
                defaultMinDateTime,
                false,
            );
            scrollToTimeOption(appointmentChoice, $('.' + appointmentChoice + ' .appt-time-option:nth-child(3)'), true); // find and scroll to the third time option scroller to this so it is centered in the list of first 5 visible options
        }
    }
}

function scrollAppointmentToTop() {
    if ($('#appointment-popup').hasClass('loading')) {
        setTimeout(
            function () {
                $('html').css('overflow', 'auto'); // required so that scrolling to top on Android works
                isMobilePage() ? $('html').scrollTop(0) : $('.mfp-wrap').scrollTop(0);
                $('#appointmentName').focus();
                $('#appointment-popup').css('opacity', '1.0');
                setBackgroundHeight();
            },
            isMobilePage() ? 1200 : 750,
        );
        $('#appointment-popup').removeClass('loading');
    }
}

function filterAndMapTimeOptionsList(
    appointmentChoice,
    openTime,
    closeTime,
    selectedDate,
    defaultMinDateTime,
    clickOnArrowToInitiateScroller,
) {
    var timeSlotDateTime = selectedDate;
    $('.' + appointmentChoice + ' .time-scroller-container').removeClass('date-has-been-selected');
    $('.' + appointmentChoice + '-time-scroller').slick('slickFilter', function () {
        // update filtered list, only keeping time selections that are available during community open hours for this day of the week
        timeSlotDateTime.setHours(parseInt(this.dataset.time24.slice(0, 2)), parseInt(this.dataset.time24.slice(3, 5))); // and filter out any time slots that are before the now+12 hour buffer window for appointments
        return (
            this.dataset.time24 >= openTime && this.dataset.time24 < closeTime && timeSlotDateTime >= defaultMinDateTime
        );
    });
    if (clickOnArrowToInitiateScroller) {
        $('.' + appointmentChoice + (isMobilePage() ? ' .leftArrow' : ' .upArrow')).click(); // hack (clicking on arrow) is required in order to fully initialize slider.  mobile slider is horizontal so use leftarrow.  desktop slider is vertical so use uparrow.
    }
    if (isMobilePage()) {
        setTimeout(function () {
            mapTimeOptionOffsets(appointmentChoice);
            if (appointmentChoice == 'appointmentSecondChoice') {
                //only scroll after second appointment choice is loaded.
                scrollAppointmentToTop();
            }
        }, 50);
    } else {
        scrollAppointmentToTop();
    }
    setTimeout(function () {
        $('.' + appointmentChoice + ' .time-scroller-container').addClass('date-has-been-selected');
    }, 500);
}

function updateSelectedDateTimes(objFromDatePicker) {
    var prettySelectedDate = '';
    var appointmentChoice =
        objFromDatePicker.id === 'appointmentFirstChoice-date' ? 'appointmentFirstChoice' : 'appointmentSecondChoice';
    var selectedTime = document.getElementById(appointmentChoice + '-time').value;
    var selectedDate = datePickerController.getSelectedDate(appointmentChoice + '-date');
    if (selectedDate) {
        prettySelectedDate = datePickerController.printFormattedDate(selectedDate, '%m/%d/%Y', true);
    }
    document.getElementById(appointmentChoice).value = prettySelectedDate + ' ' + selectedTime;
    validateAppointmentDateTime(appointmentChoice);
}

function touchUpCalendarAfterRedraw(objFromDatePicker) {
    var appointmentChoice =
        objFromDatePicker.id === 'appointmentFirstChoice-date' ? 'appointmentFirstChoice' : 'appointmentSecondChoice'; // identify the time scroller to update based on the calender that was just updated

    if ($('.' + appointmentChoice + ' .date-picker-table .prev-month').hasClass('fd-disabled')) {
        // if the datepicker calendar has disabled the prev and next month buttons, then we need to do the same with our custom prev and next buttons
        $('.' + appointmentChoice + ' .custom-calendar-header .prev-month-container .month-button')
            .prop('disabled', true)
            .addClass('disabled');
    } else {
        $('.' + appointmentChoice + ' .custom-calendar-header .prev-month-container .month-button')
            .prop('disabled', false)
            .removeClass('disabled');
    }
    if ($('.' + appointmentChoice + ' .date-picker-table .next-month').hasClass('fd-disabled')) {
        $('.' + appointmentChoice + ' .custom-calendar-header .next-month-container .month-button')
            .prop('disabled', true)
            .addClass('disabled');
    } else {
        $('.' + appointmentChoice + ' .custom-calendar-header .next-month-container .month-button')
            .prop('disabled', false)
            .removeClass('disabled');
    }
}

function setAppointmentTime(event, timeSelectedButton, appointmentChoice) {
    var $timeSelectedButton = $(timeSelectedButton);
    var prettySelectedDate = '';
    var selectedTime = $timeSelectedButton.attr('value');
    $('.' + appointmentChoice + ' .appt-time-option')
        .removeClass('time-picker-selected-time')
        .attr('aria-selected', false); // remove the flags indicating this is the selected option from all other elements
    $timeSelectedButton.addClass('time-picker-selected-time').attr('aria-selected', true); // set flags just on the selected time option
    document.getElementById(appointmentChoice + '-time').value = selectedTime; // update time field based on the time slot button selected
    if (isMobilePage()) {
        $('.' + appointmentChoice + ' .selected-time-box').addClass('time-has-been-selected');
    }
    var selectedDate = datePickerController.getSelectedDate(appointmentChoice + '-date');
    if (selectedDate) {
        prettySelectedDate = datePickerController.printFormattedDate(selectedDate, '%m/%d/%Y', true);
    }
    document.getElementById(appointmentChoice).value = prettySelectedDate + ' ' + selectedTime; // update the date-time field too
    validateAppointmentDateTime(appointmentChoice);
}

function saveSwipedPositionOffset(appointmentChoice) {
    // save off the position of the scroller (.slick-track)
    var sliderPosition = $('.' + appointmentChoice + ' .slick-track').offset();
    var sliderPositionLeft = sliderPosition.left;
    $('#' + appointmentChoice + '-time-scroller').data('savedSliderSwipedPosition', sliderPositionLeft);
}

function snapScrollToSwipedPosition(appointmentChoice) {
    // retrieve the previously saved off position, find the nearest slick-slide and snap/scroll to it
    function delta(value) {
        return Math.abs(value - savedSliderSwipedPosition);
    } // this creates an array of distances to the scrolled position
    function indexOfSmallest(a) {
        //
        var indexOfSmallestValue = 0;
        for (var i = 1; i < a.length; i++) {
            if (a[i] < a[indexOfSmallestValue]) indexOfSmallestValue = i;
        }
        return indexOfSmallestValue;
    }

    var savedSliderSwipedPosition = parseInt(
        $('#' + appointmentChoice + '-time-scroller').data('savedSliderSwipedPosition'),
        10,
    );
    var slideOffsets = $('#' + appointmentChoice + '-time-scroller').data('slideOffsetsArray');
    var slideOffsetDeltas = slideOffsets.map(delta);
    var slideIndex = indexOfSmallest(slideOffsetDeltas);
    setTimeout(function () {
        $('#' + appointmentChoice + '-time-scroller').slick('slickGoTo', slideIndex, true);
        $('.' + appointmentChoice + ' .appt-time-option.slick-center').click();
    }, 50);
}

function mapTimeOptionOffsets(appointmentChoice) {
    var slideOffset,
        slideOffsets = [],
        slickSlideIndexes = [];
    var $firstSlideSlickIndex = $('.' + appointmentChoice + ' .appt-time-option:first');
    var firstSlideSlickIndex = parseInt($firstSlideSlickIndex.data('slick-index'), 10);
    var $lastSlideSlickIndex = $('.' + appointmentChoice + ' .appt-time-option:last');
    var lastSlideSlickIndex = parseInt($lastSlideSlickIndex.data('slick-index'), 10);

    for (var slickSlideIndex = firstSlideSlickIndex; slickSlideIndex <= lastSlideSlickIndex; slickSlideIndex++) {
        slideOffset = scrollToTimeOption(
            appointmentChoice,
            $('.' + appointmentChoice + " .appt-time-option[data-slick-index='" + slickSlideIndex + "']"),
            false,
        );
        slickSlideIndexes.push(slickSlideIndex);
        slideOffsets.push(slideOffset);
    }
    $('#' + appointmentChoice + '-time-scroller').data('slideOffsetsArray', slideOffsets);
}

function scrollToTimeOption(appointmentChoice, $slideToGoTo, delayBeforeScrolling) {
    // a delayBeforeScrolling is needed if the slider is in the process of filtering the slides, otherwise the scrolling may not scroll to the correct slide
    function scroll() {
        var $verticalSlider = $('.' + appointmentChoice + '-time-scroller');
        if ($slideToGoTo) {
            var $index = $('.' + appointmentChoice + ' .appt-time-option').index($slideToGoTo[0]);
            if ($index > -1) {
                $verticalSlider.slick('slickGoTo', $index, true);
                $slideToGoTo.focus();
            }
        }
    }

    if (delayBeforeScrolling) {
        setTimeout(function () {
            scroll();
        }, 500);
    } else {
        scroll();
    }

    var sliderPosition = $('.' + appointmentChoice + ' .slick-track').offset(); // return the position of the slide scrolled to (.slick-track position)
    var sliderPositionLeft = sliderPosition.left;
    return sliderPositionLeft;
}

function timeScrollerKeyHandler(event, currentElement, appointmentChoice) {
    var option, i;
    var keycode = event.keyCode ? event.keyCode : event.which;

    if (isMobilePage()) {
        // mobile scroller is horizontal.   Also centered option is by default, selected.
        switch (keycode) {
            case 9: // check for tab or shift tab (9)
                return true; // returning true allows browser to process tab and shift tab normally.

            case 13: // check for enter key (40)
                $(currentElement).click(); // fire the click event (selecting this time option)
                event.preventDefault();
                return false;

            case 39: // check for right arrow (39)
                event.preventDefault();
                if (currentElement.nextElementSibling) {
                    $(currentElement).next().click(); // fire the click event (selecting this time option)
                }
                return false;

            case 37: // check for left arrow (38)
                event.preventDefault();
                if (currentElement.previousElementSibling) {
                    $(currentElement).prev().click(); // fire the click event (selecting this time option)
                }
                return false;

            case 36: // check for home key (36)
                event.preventDefault();
                $(currentElement).parent().children().first().click(); // fire the click event (selecting this time option)
                return false;

            case 35: // check for end key (35)
                event.preventDefault();
                $(currentElement).parent().children().last().click(); // fire the click event (selecting this time option)
                return false;

            case 33: // check for page up (34)
                option = currentElement.previousElementSibling;
                for (i = 1; i <= 4 && option; i++) {
                    // go up as many as 4 elements
                    currentElement = option;
                    option = option.previousElementSibling;
                }
                $(currentElement).click(); // fire the click event (selecting this time option)
                event.preventDefault();
                return false;

            case 34: // check for page down (34)
                option = currentElement.nextElementSibling;
                for (i = 1; i <= 4 && option; i++) {
                    // go down as many as four elements in the list
                    currentElement = option;
                    option = option.nextElementSibling;
                }
                $(currentElement).click(); // fire the click event (selecting this time option)
                event.preventDefault();
                return false;
        }
    } else {
        // desktop, scroller is vertical
        switch (keycode) {
            case 13: // check for enter key (40)
                $(currentElement).click(); // fire the click event (selecting this time option)
                event.preventDefault();
                break;

            case 40: // check for down arrow (40)
                if (currentElement.nextElementSibling) {
                    scrollToTimeOption(appointmentChoice, $(currentElement).next(), false); // go to next element in the list
                }
                event.preventDefault();
                break;

            case 38: // check for up arrow (38)
                if (currentElement.previousElementSibling) {
                    scrollToTimeOption(appointmentChoice, $(currentElement).prev(), false); // go to next element in the list
                }
                event.preventDefault();
                break;

            case 36: // check for home key (36)
                scrollToTimeOption(appointmentChoice, $(currentElement).parent().children().first(), false); // go to first element in the list
                event.preventDefault();
                break;

            case 35: // check for end key (35)
                scrollToTimeOption(appointmentChoice, $(currentElement).parent().children().last(), false); // go to last element in the list
                event.preventDefault();
                break;

            case 33: // check for page up (34)
                option = currentElement.previousElementSibling;
                for (i = 1; i <= 4 && option; i++) {
                    // go up as many as 4 elements
                    currentElement = option;
                    option = option.previousElementSibling;
                }
                scrollToTimeOption(appointmentChoice, $(currentElement), false);
                event.preventDefault();
                break;

            case 34: // check for page down (34)
                option = currentElement.nextElementSibling;
                for (i = 1; i <= 4 && option; i++) {
                    // go down as many as four elements in the list
                    currentElement = option;
                    option = option.nextElementSibling;
                }
                scrollToTimeOption(appointmentChoice, $(currentElement), false);
                event.preventDefault();
                break;
        }
    }
    return;
}

function createAppointmentTimeOptionsList() {
    function formatValue(dateTime) {
        // example output: "06:00PM" - used to forward back to server in format expected.
        var hours = dateTime.getHours();
        var mins = dateTime.getMinutes();
        var suffix = 'AM';
        if (hours >= 12) suffix = 'PM';
        if (hours > 12) hours = hours - 12;
        return make2Digits(hours) + ':' + make2Digits(mins) + suffix;
    }

    function formatTime24(dateTime) {
        // example output: "18:00" - used for time comparisons, filtering, etc.
        var hours = dateTime.getHours();
        var mins = dateTime.getMinutes();
        return make2Digits(hours) + ':' + make2Digits(mins);
    }

    function formatDisplayText(dateTime) {
        // example output: "6:00 PM" - used for displays on web page
        var hours = dateTime.getHours();
        var mins = dateTime.getMinutes();
        var suffix = 'AM';
        if (hours >= 12) suffix = 'PM';
        if (hours > 12) hours = hours - 12;
        return hours.toString() + ':' + make2Digits(mins) + "<span class='am-pm'>" + suffix + '</span>';
    }

    function buildApptTimeOptionElem(timeSlotStartDateTime) {
        return (
            '<div class="appt-time-option" aria-selected="false"  tabindex="0" value="' +
            formatValue(timeSlotStartDateTime) +
            '" data-time24="' +
            formatTime24(timeSlotStartDateTime) +
            '">' +
            formatDisplayText(timeSlotStartDateTime) +
            '</div>'
        );
    }

    function buildTimeOptionsList(appointmentChoice, startTimeHHMM, endTimeHHMM, intervalInMinutes) {
        var $timeOptionsContainer = $('#' + appointmentChoice + '-time-scroller');

        var nextTimeSlot = new Date('1/1/2000 ' + startTimeHHMM); // Any date would work here. Using the date object only to increment time and make time comparisons, so as long as the same date is used, it works.
        var closingTime = new Date('1/1/2000 ' + endTimeHHMM);
        while (nextTimeSlot.getTime() <= closingTime.getTime()) {
            var timeSlotStartDateTime = nextTimeSlot;
            var apptTimeOptionElem = buildApptTimeOptionElem(timeSlotStartDateTime);
            var $apptTimeOptionElem = $(apptTimeOptionElem).appendTo($timeOptionsContainer);

            $apptTimeOptionElem.on('click', function (event) {
                // now attach onclick and onkeyhandler to $apptTimeOptionElem
                scrollToTimeOption(appointmentChoice, $(this), false); // go to next element in the list
                setAppointmentTime(event, this, appointmentChoice);
                return false;
            });

            $apptTimeOptionElem.on('keydown', function (event) {
                return timeScrollerKeyHandler(event, this, appointmentChoice);
            });

            nextTimeSlot = new Date(Date.parse(nextTimeSlot) + intervalInMinutes * 60 * 1000); // increment time by the next interval
        }
    }

    buildTimeOptionsList('appointmentFirstChoice', '00:00', '23:59', 15);
    buildTimeOptionsList('appointmentSecondChoice', '00:00', '23:59', 15);
}

function setBackgroundHeight() {
    var appointmentPopupHeight = $('#appointment-popup').height();
    if ($('#appointmentMissingInput').css('display') === 'none') {
        appointmentPopupHeight = appointmentPopupHeight + 60; // add 60 for potential missing input error message
    }
    if ($('#appointmentError').css('display') === 'none') {
        appointmentPopupHeight = appointmentPopupHeight + 100; // add 100 for potential taller error message
    }
    if (
        $('#appointmentSelectVirtualTypeWrapper').length > 0 &&
        $('#appointmentSelectVirtualTypeWrapper').css('display') === 'none'
    ) {
        appointmentPopupHeight = appointmentPopupHeight + $('#appointmentSelectVirtualTypeWrapper').height(); // if this select element is there but not showing yet, add height for its potential expansion
    }
    if ($('#appointmentComments').css('display') === 'none') {
        appointmentPopupHeight = appointmentPopupHeight + $('#appointmentComments').height(); // if comment block is closed, add its height for its potential opening
    }
    if (appointmentPopupHeight > $('.mfp-bg').height()) {
        $('.mfp-bg').height(appointmentPopupHeight);
    }
}

function validateAppointmentDateTime(appointmentChoiceId) {
    const appointmentChoice = $('#' + appointmentChoiceId);
    let appointmentDateTimeValid = false;
    let appointmentContainer;
    if (appointmentChoiceId === 'appointmentFirstChoice') {
        appointmentContainer = $('#first-appointment-container');
    } else if (appointmentChoiceId === 'appointmentSecondChoice') {
        appointmentContainer = $('#second-appointment-container');
    }
    if (appointmentChoice.val().length === 18) {
        if (appointmentChoiceId === 'appointmentSecondChoice') {
            if (appointmentChoice.val() === $('#appointmentFirstChoice').val()) {
                $('#appointmentSecondChoiceErrorMessage').html('Appointment times must be different');
            } else {
                appointmentDateTimeValid = true;
            }
        } else {
            appointmentDateTimeValid = true;
        }
    }
    if (appointmentDateTimeValid && appointmentContainer) {
        appointmentContainer.removeClass('appointment-date-container-error');
        if ($('#' + appointmentChoiceId + 'ErrorMessage').is(':visible')) {
            // If the current appointment calendar's error message is visible, clear the current error message and display the next one
            let currentErrorMessage = formErrors.shift();
            currentErrorMessage.hide();
            if (formErrors.length > 0) {
                formErrors[0].show();
            }
        } else {
            // Else if the current appointment calendar's error message is not visible, find and remove its error message from the list
            for (let i = 0; i < formErrors.length; i++) {
                if (formErrors[i].attr('id') === appointmentChoiceId + 'ErrorMessage') {
                    formErrors.splice(i, 1);
                    break;
                }
            }
        }
    }
}

function sendAppointmentEmail(submitButton, isNotPopup, reCaptchaRequired) {
    $(submitButton).prop('disabled', true);
    const name = $('#appointmentName');
    const email = $('#appointmentEmail');
    const phone = $('#appointmentPhone');
    const moveInDate = $('#appointmentMoveInDate');
    var phoneNumber = $.trim($('#appointmentPhone').val());
    const privacyPolicyAgreement = $('#appointmentAgreeToPrivacyPolicy');
    const consentAgreement = $('#appointmentAgreeToConsent');
    const hasAdditionalConsent = consentAgreement.length > 0;
    let focusInput = null;

    if (formErrors.length > 0) {
        // If there are unfixed errors in the list clear the list, and refill.
        // this is to prevent the same error occuring multiple times in the list
        // this also ensures that the first error in the list is the first error on the page
        formErrors[0].hide();
        formErrors = [];
    }
    if (!validNameInput(name)) {
        formErrors.push($('#appointmentNameErrorMessage'));
        if (focusInput === null) {
            focusInput = name;
        }
        name.addClass('inputError');
    } else {
        name.removeClass('inputError');
    }
    if (!validEmailInput(email)) {
        formErrors.push($('#appointmentEmailErrorMessage'));
        if (focusInput === null) {
            focusInput = email;
        }
        email.addClass('inputError');
    } else {
        email.removeClass('inputError');
    }
    if (!validPhoneInput(phone)) {
        formErrors.push($('#appointmentPhoneErrorMessage'));
        if (focusInput === null) {
            focusInput = phone;
        }
        phone.addClass('inputError');
    } else {
        phone.removeClass('inputError');
    }
    if (!validDateMMDDYYYY(moveInDate, true)) {
        formErrors.push($('#appointmentMoveInDateErrorMessage'));
        if (focusInput === null) {
            focusInput = moveInDate;
        }
        moveInDate.addClass('inputError');
    } else {
        moveInDate.removeClass('inputError');
    }
    if ($.trim($('#appointmentFirstChoice').val()).length < 18) {
        formErrors.push($('#appointmentFirstChoiceErrorMessage'));
        $('#first-appointment-container').addClass('appointment-date-container-error');
        if (focusInput === null) {
            focusInput = $('#first-appointment-container');
        }
    } else {
        $('#first-appointment-container').removeClass('appointment-date-container-error');
    }
    if ($.trim($('#appointmentSecondChoice').val()).length < 18) {
        formErrors.push($('#appointmentSecondChoiceErrorMessage'));
        $('#second-appointment-container').addClass('appointment-date-container-error');
        if (focusInput === null) {
            focusInput = $('#second-appointment-container');
        }
    } else if ($.trim($('#appointmentFirstChoice').val()) === $.trim($('#appointmentSecondChoice').val())) {
        $('#appointmentSecondChoiceErrorMessage').html('Appointment times must be different');
        formErrors.push($('#appointmentSecondChoiceErrorMessage'));
        $('#second-appointment-container').addClass('appointment-date-container-error');
        if (focusInput === null) {
            focusInput = $('#second-appointment-container');
        }
    } else {
        $('#second-appointment-container').removeClass('appointment-date-container-error');
    }

    if (!privacyPolicyAgreement.prop('checked')) {
        formErrors.push($('#appointmentAgreeToPrivacyPolicyErrorMessage'));
        if (focusInput === null) {
            focusInput = privacyPolicyAgreement;
        }
        privacyPolicyAgreement.siblings()[0].classList.add('inputError');
    } else {
        privacyPolicyAgreement.siblings()[0].classList.remove('inputError');
    }

    let reCaptchaWidgetId = null;
    let reCaptchaToken = null;
    if (reCaptchaRequired) {
        reCaptchaWidgetId = 'appointment-popup-recaptcha';
        reCaptchaToken = grecaptcha.enterprise.getResponse(reCaptchaWidgets[reCaptchaWidgetId]);
        if (reCaptchaToken === '') {
            formErrors.push($('#' + reCaptchaWidgetId + 'ErrorMessage'));
            document.getElementById(reCaptchaWidgetId).classList.add('inputError');
        } else {
            document.getElementById(reCaptchaWidgetId).classList.remove('inputError');
        }
    }

    if (formErrors.length > 0) {
        formErrors[0].show();
        if (focusInput !== null) {
            if (
                focusInput.attr('id') === 'first-appointment-container' ||
                focusInput.attr('id') === 'second-appointment-container'
            ) {
                focusInput.get(0).scrollIntoView();
            } else {
                focusInput.focus();
            }
        }
        $(submitButton).prop('disabled', false);
        return false;
    }

    $('#appointmentError').hide();
    var json = new Object();
    json['t'] = $('#emailType').val();
    json['n'] = $('#appointmentName').val();
    json['e'] = $('#appointmentEmail').val();
    json['p'] = phoneNumber;
    json['mi'] = $('#appointmentMoveInDate').val();
    json['afc'] = $('#appointmentFirstChoice').val();
    json['asc'] = $('#appointmentSecondChoice').val();
    // check checkbox
    if ($('#includeMessage').prop('checked')) {
        json['c'] = $('#appointmentComments').val();
    }
    if ($('#appointmentFloorplan').length && $('#appointmentFloorplan').val().length > 0) {
        json['f'] = $('#appointmentFloorplan').val();
        json['fpn'] = $('#appointmentFloorplanName').val();
    } else if ($('#appointmentSelectFloorplan').length && $('#appointmentSelectFloorplan').val().length > 0) {
        json['f'] = $('#appointmentSelectFloorplan').val();
    } else {
        json['ci'] = $('#appointmentCommunity').val();
    }
    var hasAppointmentSelectType = false;
    if ($('#appointmentSelectType').length) {
        json['ast'] = $('#appointmentSelectType').val();
        hasAppointmentSelectType = true;
    }
    var hasAppointmentVirtualPlatform = false;
    if ($('#appointmentSelectVirtualPlatform').length) {
        json['avp'] = $('#appointmentSelectVirtualPlatform').val();
        hasAppointmentVirtualPlatform = true;
    }
    json['cn'] = $('#appointmentCommunityName').val();
    if (hasAdditionalConsent) {
        // see ADDITIONAL_CONSENT in ContactPropertyManagerEmail.java
        json['ac'] = consentAgreement.prop('checked') ? 'Yes' : 'No';
    }
    json['cap'] = $('#appointmentCaptchaEntry').val();
    json['cs'] = $('#appointmentCaptchaSession').val();
    json['u'] = $(location).attr('href');
    json['guid'] = $('#emailGuid').val();
    json['ks'] = getLocalStorageItemByPrefix('knock-source');
    json['ills'] = $('#emailSource').val();

    if (reCaptchaRequired && reCaptchaToken) {
        json['reCaptchaToken'] = reCaptchaToken;
    }

    $('#appointmentLoader').show();
    var request = $.ajax({
        url: '/rapi/server/email/contact-property',
        type: 'POST',
        data: json,
    });
    request.done(function (msg) {
        $('#appointmentLoader').hide();
        $(submitButton).prop('disabled', false);
        if (msg['m'] != null) {
            if (isNotPopup) {
                magnificGenerator('<h3>Error</h3><p>' + msg['m'] + '</p>', 'error', 'Continue');
            } else {
                $('#appointmentError').html(msg['m']);
                $('#appointmentError').show();
                isMobilePage() ? $('html').scrollTop(0) : $('.mfp-wrap').scrollTop(0);
            }
        } else {
            $('#appointmentError').hide();
            $('#appointmentName').val('');
            $('#appointmentEmail').val('');
            $('#appointmentPhone').val('');
            $('#appointmentMoveInDate').val('');
            $('#appointmentSelectFloorplan').val('');
            if (hasAppointmentSelectType) {
                $('#appointmentSelectType').val('');
            }
            if (hasAppointmentVirtualPlatform) {
                $('#appointmentSelectVirtualPlatform').val('');
                if (hasAppointmentSelectType) {
                    $('#appointmentSelectVirtualTypeWrapper').hide();
                }
            }
            $('#appointmentFirstChoice').val('');
            $('#appointmentSecondChoice').val('');
            $('#includeMessage').prop('checked', false);
            privacyPolicyAgreement.prop('checked', false);
            if (hasAdditionalConsent) {
                consentAgreement.prop('checked', false);
            }
            $('#appointmentSelectFloorplanWrapper').hide();
            $('#appointmentComments').val('');
            $('#appointmentComments').hide();
            if (isNotPopup) {
                magnificGenerator(
                    '<h3>Success</h3><p>Thank you for reaching out! Please note, we cannot guarantee preferred appointment times but will make every effort to accommodate your request. A team member will contact you as soon as possible to confirm an appointment time!</p>',
                    'success',
                    'Continue',
                );
            } else {
                try {
                    $.magnificPopup.close();
                } catch (err) {
                    //Nothing
                }
                magnificGenerator(
                    '<h3>Success</h3><p>Thank you for reaching out! Please note, we cannot guarantee preferred appointment times but will make every effort to accommodate your request. A member of our staff will contact you as soon as possible to confirm an appointment time!</p>',
                    'success',
                    'Continue',
                );
                if (isMobilePage()) {
                    $('.mfp-wrap').css('top', '0');
                    $('html').scrollTop(0);
                }
            }
            $('#appointmentFirstChoice').val('');
            $('#appointmentSecondChoice').val('');
            $('.time-picker-selected-time').removeClass('slick-current time-picker-selected-time');
            $('.date-picker-selected-date').removeClass('date-picker-selected-date');
            $('.time-scroller-container').removeClass('date-has-been-selected');
            $('.selected-time-box').removeClass('time-has-been-selected');
            $('#appointmentFirstChoice-time, #appointmentSecondChoice-time').val('');
            $('#appointmentSelectFloorplan, #appointmentSelectType, #appointmentSelectVirtualPlatform').removeClass(
                'hasValue',
            );
            $('#appointmentSelectFloorplan').prop('selectedIndex', 0);
            $('#appointmentSelectType').prop('selectedIndex', 0);
            $('#appointmentSelectVirtualPlatform').prop('selectedIndex', 0);
            datePickerController.destroyDatePicker('appointmentFirstChoice-date');
            datePickerController.destroyDatePicker('appointmentSecondChoice-date');
            if ($('#appointmentFloorplan').length) {
                trackEvent('Send Email', 'Floorplan', $('#appointmentFloorplan').val());
            } else {
                trackEvent('Send Email', 'Community', $('#appointmentCommunity').val());
            }
            trackGA4Event('rv_cv_submit_appointment');
        }
        if (reCaptchaRequired) {
            grecaptcha.enterprise.reset(reCaptchaWidgets[reCaptchaWidgetId]);
        }
    });
    request.fail(function (jqXHR, textStatus) {
        $('#appointmentLoader').hide();
        if (isNotPopup) {
            magnificGenerator(
                '<h3>Error</h3><p>We were unable to send the email, please try again.</p>',
                'error',
                'Continue',
            );
        } else {
            $('#appointmentError').html('We were unable to send the email, please try again.');
            $('#appointmentError').show();
            isMobilePage() ? $('html').scrollTop(0) : $('.mfp-wrap').scrollTop(0);
        }
        $(submitButton).prop('disabled', false);
        if (reCaptchaRequired) {
            grecaptcha.enterprise.reset(reCaptchaWidgets[reCaptchaWidgetId]);
        }
    });
}

/**
 * Calculate the new opening time with a given buffer before the set open time.
 * This code calculates a new opening time when given a new buffer size. For example, if it is changed to 30, the new
 * opening time would be 9:30 instead of 9:00.
 * @param openHour
 * @param openMinute
 * @param buffer
 * @return {string} The resulting close time in the format "hh:mm" like "18:45".
 */
function calculateOpenTimeWithBuffer(openHour, openMinute, buffer) {
    // Round up to the nearest 15
    const roundedBuffer = Math.ceil(buffer / 15) * 15;

    // Grab number of hours from buffer
    const bufferHours = Math.floor(roundedBuffer / 60);

    // Grab number of minutes from buffer
    const bufferMinutes = roundedBuffer % 60;

    // Carry the 1
    if (bufferMinutes > 0 && openMinute + bufferMinutes >= 60) {
        openHour += 1;
        openMinute -= 60;
    }

    // Calculate new "opening time" using the buffer
    return (
        (openHour + bufferHours).toString().padStart(2, '0') +
        ':' +
        (openMinute + bufferMinutes).toString().padEnd(2, '0')
    );
}

/**
 * Calculate the new closing time with a given buffer before the set close time.
 * The default buffer is 15 minutes due to the way it limits the times in the time picker.
 * This means that if the closing time is 9:00, the last time it would show for an appointment is 8:45
 * This code calculates a new closing time when given a new buffer size. For example, if it is changed to 30, the new
 * closing time would be 8:30 instead of 8:45.
 * @param closeHour
 * @param closeMinute
 * @param buffer
 * @return {string} The resulting close time in the format "hh:mm" like "18:45".
 */
function calculateCloseTimeWithBuffer(closeHour, closeMinute, buffer) {
    // Round up to the nearest 15
    var roundedBuffer = Math.ceil(buffer / 15) * 15;

    // Subtract 15 minutes from the buffer to get the corrected buffer time
    var correctedBuffer = roundedBuffer > 0 ? roundedBuffer - 15 : 0;

    // Grab number of hours from buffer
    var bufferHours = Math.floor(correctedBuffer / 60);

    // Grab number of minutes from buffer
    var bufferMinutes = correctedBuffer % 60;

    // Carry the 1
    if (bufferMinutes > 0 && closeMinute < bufferMinutes) {
        closeHour -= 1;
        closeMinute += 60;
    }

    // Calculate new "closing time" using the buffer
    return (
        (closeHour - bufferHours).toString().padStart(2, '0') +
        ':' +
        (closeMinute - bufferMinutes).toString().padEnd(2, '0')
    );
}

// Not using modules in browser, so don't try to call module.exports if module doesn't exist.
// The call to module.exports allows us to import this for unit testing.
try {
    if (module) {
        module.exports = {
            calculateOpenTimeWithBuffer,
            calculateCloseTimeWithBuffer,
        };
    }
} catch (err) {
    //do nothing
}
